// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"49cce50c","965":"865dd8cb"}[chunkId] + ".chunk.js";
};